import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import { store } from "@/store/store";
import vuetify from "./plugins/vuetify";
import i18n from "@/i18n/i18n";
//@ts-ignore
import VeeValidate, { Validator } from "vee-validate";
import { validateLocaleEs } from "@/vee-validate/locale/es";
import PublicPathModule from '@/store/modules/public-path-module';
import { VueInstanceService } from './shared/services/vue-instance-service';
import { UtilsString } from './utils/utils-string';
import { UtilsDate } from "./utils/utils-date";


import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.material.blue.light.css';
//import '@/assets/css/dx.material.my-medical-diet-theme.css';

//import "@/assets/css/dx.material.my-medical-diet-theme.css";

import esMessages from "devextreme/localization/messages/es.json";
import { locale, loadMessages} from "devextreme/localization";
import qr_code from '@/views/QR/qr_code.vue'
import qr_code_normal from '@/views/QR/qr_code_normal.vue'
import { ssmPermissionService } from "./shared/services/PermissionService";

loadMessages(esMessages);

locale("es");

const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg: string, vm: any, trace: any) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = "";
    //vm = null;
    trace = "";
  }
}

Vue.config.productionTip = false;
//@ts-ignore
PublicPathModule.setPublicPath(process.env.VUE_APP_PUBLIC_PATH as string);
//@ts-ignore
Vue.use(VeeValidate, { inject: false, delay: 1 });
// Localize takes the locale object as the second argument (optional) and merges it.
Validator.localize("es", validateLocaleEs);
Vue.prototype.$ValueOf = UtilsString.ValueOf;
Vue.prototype.$IsEmptyTextPutThis = UtilsString.IsEmptyTextPutThis;
Vue.prototype.$log = console.log;
Vue.prototype.$format_date = UtilsDate.FormatDateBack;
Vue.prototype.$hasPermission =ssmPermissionService.hasPermission;
//Definicion de componentes publicos
Vue.component('qr-code',qr_code )
Vue.component('qr-code-normal',qr_code_normal )
VueInstanceService.vueinstance = new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h: any) => h(App)

}).$mount("#app");

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})
router.beforeEach((to: any, from: any, next: any) => {
  next();
});
